import React from 'react'
import { motion } from 'framer-motion'
import { Shield, Star, Zap, Users } from 'lucide-react'
import { TRUST_FEATURES } from '../constants'
import Container from './Container'
import AnimatedSection from './AnimatedSection'
import { staggerContainerVariants, staggerItemVariants } from '../utils/animations'

/**
 * TrustSection - Credibility block with 4 feature cards
 * "Compra con claridad. Invierte con seguridad."
 */

const iconMap: {
  [key: string]: React.ComponentType<{ className?: string; 'aria-hidden'?: boolean }>
} = {
  shield: Shield,
  star: Star,
  zap: Zap,
  users: Users,
}

const TrustSection: React.FC = () => {
  return (
    <section className="bg-background py-24 md:py-32">
      <Container size="xl">
        {/* Section Header */}
        <AnimatedSection className="mx-auto mb-16 max-w-3xl text-center">
          {/* Section Label */}
          <span className="section-label mb-4 block">Diferenciales</span>
          <h2 className="accent-line-center mb-6 text-3xl font-bold text-primary md:text-4xl lg:text-5xl">
            Compra con claridad. Invierte con seguridad.
          </h2>
          <p className="text-lg text-text-secondary">
            Nuestro enfoque se basa en selección exigente, transparencia y acompañamiento de
            principio a fin.
          </p>
        </AnimatedSection>

        {/* Feature Cards Grid */}
        <motion.div
          className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8"
          variants={staggerContainerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: '-100px' }}
        >
          {TRUST_FEATURES.map((feature) => {
            const IconComponent = iconMap[feature.icon]
            return (
              <motion.div
                key={feature.id}
                variants={staggerItemVariants}
                className="card-hover group rounded-xl border border-border-light bg-surface p-8"
              >
                {/* Icon */}
                <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-xl bg-accent/10 transition-colors group-hover:bg-accent/20">
                  {IconComponent && (
                    <IconComponent className="h-7 w-7 text-accent" aria-hidden={true} />
                  )}
                </div>

                {/* Title */}
                <h3 className="mb-3 text-xl font-semibold text-primary">{feature.title}</h3>

                {/* Description */}
                <p className="leading-relaxed text-text-secondary">{feature.description}</p>
              </motion.div>
            )
          })}
        </motion.div>
      </Container>
    </section>
  )
}

export default TrustSection
